import React, { Component } from 'react';
import { Card, Spin, message } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import CalendarModule from './CalendarModule';
import TodoListModule from './TodoListModule';
import MemoModule from './MemoModule';
import './index.less';

class MonthlyPlan extends Component {
    state = {
        hasPermission: null,
        loading: false,
        selectedDate: '',
        selectedMonth: '',
        calendarRefreshKey: 0,
    };

    componentDidMount() {
        const now = new Date();
        const dateStr = this.formatDate(now);
        const monthStr = this.formatYearMonth(now);

        const planMonth = sessionStorage.getItem('_planMonth');
        if (planMonth) {
            sessionStorage.removeItem('_planMonth');
            this.setState({ selectedDate: dateStr, selectedMonth: planMonth });
        } else {
            this.setState({ selectedDate: dateStr, selectedMonth: monthStr });
        }
        this.checkPermission();
    }

    formatDate = (date) => {
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        return `${y}-${m}-${d}`;
    };

    formatYearMonth = (date) => {
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, '0');
        return `${y}-${m}`;
    };

    checkPermission = () => {
        const { userId } = sessionStorage;
        const options = {
            method: 'POST',
            url: API_URL.monthlyPlan.checkPermission,
            data: { curUserId: userId },
            dataType: 'json',
            doneResult: (res) => {
                if (res.success) {
                    this.setState({ hasPermission: res.data.hasPermission });
                    if (!res.data.hasPermission) {
                        message.warning(res.data.message);
                    }
                }
            },
        };
        $.sendRequest(options);
    };

    handleMonthChange = (selectedMonth) => {
        this.setState({ selectedMonth });
    };

    handleDateSelect = (selectedDate) => {
        this.setState({ selectedDate });
    };

    handleMemoSaved = () => {
        this.setState((prev) => ({ calendarRefreshKey: prev.calendarRefreshKey + 1 }));
    };

    render() {
        const { hasPermission, loading, selectedDate, selectedMonth, calendarRefreshKey } = this.state;

        if (hasPermission === null) {
            return <Spin spinning={true} />;
        }

        if (!hasPermission) {
            return (
                <Card>
                    <div className="monthlyPlan-no-permission">
                        当前用户无权限查看年度/月度计划内容
                    </div>
                </Card>
            );
        }

        return (
            <div className="monthlyPlan-container">
                <div className="monthlyPlan-left">
                    <CalendarModule
                        selectedMonth={selectedMonth}
                        selectedDate={selectedDate}
                        refreshKey={calendarRefreshKey}
                        onMonthChange={this.handleMonthChange}
                        onDateSelect={this.handleDateSelect}
                    />
                    <MemoModule selectedDate={selectedDate} onMemoSaved={this.handleMemoSaved} />
                </div>
                <div className="monthlyPlan-right">
                    <TodoListModule selectedDate={selectedDate} />
                </div>
            </div>
        );
    }
}

export default MonthlyPlan;



// WEBPACK FOOTER //
// ./src/components/homePage/monthlyPlan/index.js